import { Routes } from '@angular/router';
import { permisoGuard } from '../core/auth/permiso.guard';
import { Permiso } from '../core/auth/permisos';

/** Sección a la que pertenecen estas pantallas (encabezado de la bandeja). */
const SECCION = 'Hematología (HEMA)';

/**
 * Sección de Hematología (HEMA). Una sola pantalla: el hemograma completo y la
 * investigación de hemoparásitos se capturan e informan juntos en el
 * IHIMV-RT-21-HEMA, así que los dos diagnósticos del catálogo comparten bandeja.
 */
export const hematologiaRoutes: Routes = [
  {
    path: 'hematologia/hemograma',
    canActivate: [permisoGuard],
    loadComponent: () =>
      import('../shared/analisis/bandeja-diagnostico/bandeja-diagnostico.page').then(
        (m) => m.BandejaDiagnosticoPage,
      ),
    title: 'SiLabVet | Hemograma y Hemoparásitos',
    data: {
      pantalla: 'HEMOGRAMA',
      breadcrumb: SECCION,
      titulo: 'Hemograma y Hemoparásitos',
      permiso: Permiso.HEMOGRAMA_VER,
    },
  },
  {
    path: 'hematologia/hemograma/:id/trabajar',
    canActivate: [permisoGuard],
    data: { permiso: [Permiso.HEMOGRAMA_RESULTADOS, Permiso.HEMOGRAMA_VER] },
    loadComponent: () =>
      import('./pages/hemograma-resultados/hemograma-resultados.page').then(
        (m) => m.HemogramaResultadosPage,
      ),
    title: 'SiLabVet | Informe de resultados — Hemograma y Hemoparásitos',
  },
];
